import React from "react";
import { LegalDocument } from "@/legal/LegalDocument";
import { TERMS, PRIVACY_POLICY, LEGAL_NOTICE } from "@/legal/legalText";

const Section = ({ id, title, children }) => (
  <div className="tc-card p-5" data-testid={`legal-${id}`}>
    <h2 className="font-heading text-lg font-bold">{title}</h2>
    <div className="text-tc-sub text-sm mt-2 space-y-2">{children}</div>
  </div>
);

export default function Legal() {
  return (
    <div className="p-6 lg:p-8 max-w-3xl mx-auto space-y-4" data-testid="legal-page">
      <h1 className="font-heading text-3xl font-extrabold">Legal & Trust</h1>
      <div className="text-[11px] font-mono text-tc-mastery" data-testid="legal-notice">{LEGAL_NOTICE}</div>

      <Section id="disclaimer" title="Educational / Informational Disclaimer">
        <p>TRADECRAFT provides education, analytical tools, and AI-assisted market analysis. It does <b>not</b> provide financial advice, does <b>not</b> guarantee outcomes, and does <b>not</b> tell you what to trade. You remain responsible for your decisions.</p>
        <p>TRADECRAFT V1 does not execute real-money trades and has no brokerage or exchange connectivity.</p>
      </Section>
      <Section id="ai" title="AI Transparency">
        <p>Objective, deterministic market evidence is calculated by our engine and is authoritative for factual values. AI (Claude) provides interpretation and synthesis — it can be wrong, and it never overwrites deterministic facts.</p>
        <p>We clearly separate <b>Market Evidence</b>, <b>AI Interpretation</b>, and <b>Your Thesis</b> throughout the product.</p>
      </Section>
      <Section id="data" title="Data & Provider Attribution">
        <p>Live and historical market data is sourced from public exchange/data APIs (e.g., Binance.US, Coinbase, CoinGecko). Data may be delayed or temporarily unavailable; TRADECRAFT surfaces freshness and degrades gracefully rather than fabricating values.</p>
      </Section>
      <div className="tc-card p-5" data-testid="legal-terms"><LegalDocument doc={TERMS} /></div>
      <div className="tc-card p-5" data-testid="legal-privacy"><LegalDocument doc={PRIVACY_POLICY} /></div>
      <Section id="billing" title="Subscription & Billing Terms">
        <p>TRADECRAFT Pro is $39 per month or $348 per year, and TRADECRAFT Family is $59 per month or $528 per year. Paid subscriptions are billed through Stripe at the price and billing interval shown at checkout, and renew until cancelled. Cancelling stops renewal; access continues until the end of the current billing period, after which your account returns to the Free plan with your competency history preserved. A Free account never requires a card. See the Terms &amp; Conditions for full subscription terms.</p>
      </Section>
    </div>
  );
}
